import ReactModal from 'react-modal';
import { any, bool, object, string, func } from 'prop-types';
import { ModalHeader } from './ModalComponents';

const Modal = ({
  id = 'react-modal',
  isModalOpen = false,
  title = '',
  onClose = () => {},
  children,
  Icon,
  titleStyle = 'delete-title',
  iconStyle = 'ic-success',
  isMailModal = false,
  RightButtonType = '',
  RightButtonOnClick = null,
  classCondition = false,
  titleClass = '',
  ...rest
}) => {
  return (
    <ReactModal
      ariaHideApp={false}
      id={id}
      {...rest}
      isOpen={isModalOpen}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="">
        <ModalHeader
          id={id}
          title={title}
          onClose={onClose}
          Icon={Icon}
          titleStyle={titleStyle}
          iconStyle={iconStyle}
          isMailModal={isMailModal}
          RightButtonType={RightButtonType}
          RightButtonOnClick={RightButtonOnClick}
          classCondition={classCondition}
          titleClass={titleClass}
          {...rest}
        />
        {children}
      </div>
    </ReactModal>
  );
};

Modal.propTypes = {
  id: any,
  isModalOpen: bool,
  rest: object,
  title: string,
  onClose: func,
  titleStyle: string,
  iconStyle: string,
};

export default Modal;
